import {
  AREA_TYPES, TREE_TYPES, DEFAULT_PLANT_DENSITY, getAreaTypeLabel, getAreaTypeColor,
} from '../../SiteTakeoff/siteTakeoffConstants';

// Area object for a hand-placed point marker. Tree-disposition markers seed
// one tree so arborist pricing and the Trees stat count them, matching the
// placement queue (usePlacementQueue writes treeCount: 1).
export const buildPointMarkerArea = ({ lat, lng }) => {
  const defaultType = AREA_TYPES.TREE_REMAIN;
  return {
    geometryType: 'point',
    name: getAreaTypeLabel(defaultType),
    areaType: defaultType,
    paths: [{ lat, lng }],
    area: '0',
    areaAcres: '0',
    perimeter: '0',
    fillColor: getAreaTypeColor(defaultType),
    strokeColor: '#000000',
    ...(TREE_TYPES.includes(defaultType)
      ? { plantDensity: { ...DEFAULT_PLANT_DENSITY, treeCount: 1 } }
      : {}),
  };
};

// Area object for a circle-drawn zone. Defaults to a serviceable turf type
// (parity with polygons) — ELLIPSE_ZONE stays available as a deliberate
// annotation type via the editor, but drawing a circle must not silently
// produce a zero-service area whose SF prints on the proposal priced at $0.
export const buildCircleArea = ({ lat, lng, radiusMeters }) => {
  const radiusFeet = radiusMeters * 3.28084;
  const areaSF = Math.PI * radiusFeet * radiusFeet;
  const perimeterFeet = 2 * Math.PI * radiusFeet;
  const defaultType = AREA_TYPES.NT_TURF_OPEN;
  return {
    geometryType: 'ellipse',
    name: getAreaTypeLabel(defaultType),
    areaType: defaultType,
    paths: [{ lat, lng }],
    radiusX: parseFloat(radiusFeet.toFixed(2)),
    radiusY: parseFloat(radiusFeet.toFixed(2)),
    area: areaSF.toFixed(2),
    areaAcres: (areaSF / 43560).toFixed(4),
    perimeter: perimeterFeet.toFixed(2),
    fillColor: getAreaTypeColor(defaultType),
    strokeColor: '#000000',
  };
};
